const productImage = "https://media.dev.vexprotech.com/"

module.exports = productImage;